import React, { useState, ReactNode, useEffect } from 'react';
import { Tabs, Tab, Box } from "@mui/material";
import SearchInput from '../atoms/SearchInput';
import ManageUserTable from '../organisms/ManageUserTable';
import { User, UserDetails } from '../types/User';
import SectionHeader from '../molecules/SectionHeader';
import WindowHeightComponent from '../../Layouts/WindowHeight';
import UserModal from '../molecules/UserModal';
import Spinner from '../atoms/Spinner';

interface TabPanelProps {
  children: ReactNode;
  value: number;
  index: number;
}

interface RoleOption {
  label: string;
  value: string;
  id?: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

interface ManageUsersTemplateProps {
  tabValue: number;
  search: string;
  users: User[];
  roleOptions: RoleOption[];
  onEdit: (user: User) => void;

  setUsers: React.Dispatch<React.SetStateAction<UserDetails[]>>;
  onUserStatusChange: (userId: number, newStatus: string) => void;
  loading: boolean;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRoleChange: (username: string, roles: string) => void;
  onSaveAll: () => void;
  clientErrors: string[];
  error:String
}

const ManageUsersTemplate: React.FC<ManageUsersTemplateProps> = ({
  tabValue,
  search,
  users,
  roleOptions,
  setUsers,
  onEdit,
  onUserStatusChange,
  onTabChange,
  onSearchChange,
  onRoleChange,
  onSaveAll,
  error,
  clientErrors,
  loading
}) => {
  if (loading) {
    return (
        <Spinner/>
  
    );
  }
  const filteredUsers = users.filter(user => {
    const isActive = user.status === "active"
    return tabValue === 0 ? isActive : !isActive;
  });



  return (
    <>


      {/* {clientErrors.length > 0 && (
        <div className="alert alert-danger">
          <ul>
            {clientErrors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      )} */}

      <WindowHeightComponent className={''}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={tabValue}
            onChange={onTabChange}
            aria-label="user status tabs"
          >
            <Tab label="Active" />
            <Tab label="Inactive" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <div className="p-3">
            <SearchInput value={search} onChange={onSearchChange} />
            {filteredUsers.length > 0 ? (
              <ManageUserTable
                users={filteredUsers}
                setUsers={setUsers}
                roleOptions={roleOptions}
                onRoleChange={onRoleChange}
                onUserStatusChange={onUserStatusChange}
                onEdit={onEdit} 
                onSaveAll={onSaveAll}
              />
            ):(
              <div className="text-center text-gray-500 mt-4">{error}</div>
            )}
          </div>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <div className="p-3">
            <SearchInput value={search} onChange={onSearchChange} />
            {filteredUsers.length > 0 ? (
              <ManageUserTable
                users={filteredUsers}
                setUsers={setUsers}
                roleOptions={roleOptions}
                onEdit={onEdit} 
                onUserStatusChange={onUserStatusChange}
                onRoleChange={onRoleChange}
                onSaveAll={onSaveAll}
              />
            ):(
              <div className="text-center text-gray-500 mt-4">{error}</div>
            )}
          </div>
        </TabPanel>
      </WindowHeightComponent>


    </>
  );
};

export default ManageUsersTemplate;
